import React from 'react';
import styles from './header.module.scss';
import { DocWidth, AppWidth, Flex, Link, P } from '@tpr/core';
export var Header = function (_a) {
    var logoSrc = _a.logoSrc, logoHref = _a.logoHref, _b = _a.logoAlt, logoAlt = _b === void 0 ? 'Go to The Pensions Regulator website' : _b, _c = _a.title, title = _c === void 0 ? 'Exchange - Scheme Return' : _c, onClickLogout = _a.onClickLogout, schemeOptionsHref = _a.schemeOptionsHref;
    return (React.createElement(DocWidth, { className: styles.headerBackground },
        React.createElement(AppWidth, null,
            React.createElement(Flex, { cfg: { justifyContent: 'space-between', py: 2, pr: 6 } },
                React.createElement(Flex, { cfg: { alignItems: 'center' } },
                    React.createElement("a", { href: logoHref, className: styles.logo },
                        React.createElement("img", { className: styles.img, src: logoSrc, alt: logoAlt, width: "180", height: "75" }))),
                React.createElement(Flex, { cfg: {
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: 10,
                    } },
                    React.createElement(P, { cfg: {
                            color: 'white',
                            fontSize: 3,
                            fontWeight: 3,
                            lineHeight: 5,
                            my: 1,
                        } }, title),
                    React.createElement(Flex, null,
                        React.createElement(Link, { href: schemeOptionsHref, underline: true, "data-testid": "onClickSchemeOptions", cfg: { mr: 4 }, className: styles.headerlink }, "Scheme Options"),
                        React.createElement(Link, { onClick: onClickLogout, underline: true, "data-testid": "onClickLogout", className: styles.headerlink }, "Log out")))))));
};
//# sourceMappingURL=header.js.map